export class ManualUnschedulerEventModel {
    Id: number;
    PlantId: number;
    LineId: number;
    Title: string;
    StartDate: string;
    EventStartTime: string;
    EndDate: string;
    EventEndTime: string;
    RecursionRuleId: number | null;
    CreatedBy: string;
    CreatedOn: Date;
    UpdatedOn: Date;
    ShiftScheduleId: number | null;

    constructor(obj: any){
        this.Id = obj?.Id ?? obj?.id ?? 0;
        this.PlantId = obj?.PlantId ?? obj?.plantId ?? 0;
        this.LineId = obj?.LineId ?? obj?.lineId ?? 0;
        this.Title = obj?.Title ?? obj?.title ?? '';
        this.StartDate = obj?.StartDate ?? obj?.startDate ?? new Date().toDateString();
        this.EventStartTime = obj?.EventStartTime ?? obj?.eventStartTime ?? "";
        this.EndDate = obj?.EndDate ?? obj?.endDate ?? new Date().toDateString();
        this.EventEndTime = obj?.EventEndTime ?? obj?.eventEndTime ?? "";
        this.RecursionRuleId = obj?.RecursionRuleId ?? obj?.recursionRuleId ?? null;
        this.CreatedBy = obj?.CreatedBy ?? obj?.createdBy ?? '';
        this.CreatedOn = obj?.CreatedOn ?? (obj?.createdOn && new Date(obj?.createdOn)) ?? new Date();
        this.UpdatedOn = obj?.UpdatedOn ?? (obj?.updatedOn && new Date(obj?.updatedOn)) ?? new Date();
        this.ShiftScheduleId = obj?.ShiftScheduleId ?? obj?.shiftScheduleId ?? null;
    }
}